import { loadModules } from 'esri-loader';
import appConfig from '../config/appConfig';

export default class Countries {
  constructor(props) {
    this.props = props;
  }

  async getCountries() {
    const [QueryTask, Query] = await loadModules([
      'esri/tasks/QueryTask',
      'esri/tasks/support/Query'
    ]);
    const queryTask = new QueryTask({
      url: this.props.url
    });
    const query = new Query();
    query.where = this.props.where;
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.outFields = appConfig.countryData.outFields;

    const response = await queryTask.execute(query);
    const countriesData =
      response.features && response.features.length > 0
        ? response.features.map((f) => {
            return f.attributes;
          })
        : null;
    return countriesData;
  }

  async getCountryInfoByName(name) {
    const [QueryTask, Query] = await loadModules([
      'esri/tasks/QueryTask',
      'esri/tasks/support/Query'
    ]);
    const queryTask = new QueryTask({
      url: this.props.url
    });
    const query = new Query();
    query.where = `LOWER(${this.props.countryField}) = LOWER('${name}')`;
    query.returnDistinctValues = true;
    query.returnGeometry = false;
    query.outFields = ['*'];

    const response = await queryTask.execute(query);
    return response.features && response.features.length > 0
      ? response.features[0].attributes
      : null;
  }
}
